module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.hideHeader) ? _c('dashboard-header', {
    attrs: {
      "data-tour": "header"
    },
    on: {
      "tour": _vm.startTour
    }
  }) : _vm._e(), _vm._v(" "), (_vm.segmentationEnabled) ? _c('ai-credits-banner') : _vm._e(), _vm._v(" "), _c('no-data-modal', {
    attrs: {
      "visible": !!_vm.notice && _vm.dismissedNotice !== _vm.notice.key,
      "refreshing": _vm.refreshing,
      "icon": _vm.notice ? _vm.notice.icon : undefined,
      "title": _vm.notice ? _vm.notice.title : undefined,
      "text": _vm.notice ? _vm.notice.text : undefined,
      "hint": _vm.notice ? _vm.notice.hint : undefined,
      "tone": _vm.notice ? _vm.notice.tone : undefined,
      "show-refresh": _vm.notice ? _vm.notice.refresh : true,
      "loading": !!_vm.notice && !!_vm.notice.loading,
      "progress": _vm.notice && _vm.notice.progress ? _vm.notice.progress : 0,
      "progress-text": _vm.notice && _vm.notice.progressText ? _vm.notice.progressText : ''
    },
    on: {
      "close": function($event) {
        _vm.dismissedNotice = _vm.notice.key
      },
      "refresh": function($event) {
        return _vm.$emit('refresh')
      }
    }
  }), _vm._v(" "), _c('segments-overview', {
    attrs: {
      "summary": _vm.summary,
      "insights": _vm.insights,
      "segment-stats": _vm.segmentStats,
      "segment-tags": _vm.segmentTags,
      "active-segment": _vm.activeSegment,
      "loading-summary": _vm.loadingSummary,
      "loading-insights": _vm.loadingInsights,
      "freshness": _vm.segmentFreshness,
      "refreshing": _vm.refreshing
    },
    on: {
      "refresh": function($event) {
        return _vm.$emit('refresh')
      },
      "segment-click": _vm.handleSegmentClick
    }
  }), _vm._v(" "), _c('engagement-overview', {
    attrs: {
      "audience-profiles": _vm.audienceProfiles,
      "cross-channel": _vm.crossChannel,
      "completeness": _vm.completeness,
      "loading-aggregate": _vm.loadingAggregate,
      "loading-completeness": _vm.loadingCompleteness
    },
    on: {
      "export-pair": function($event) {
        return _vm.startExport($event)
      }
    }
  }), _vm._v(" "), _c('listener-retargeting', {
    attrs: {
      "data-tour": "listeners",
      "listeners": _vm.listeners.listeners || [],
      "total": _vm.listeners.totalMatches || 0,
      "loading": _vm.loadingListeners,
      "visible": _vm.showListeners,
      "has-brief": _vm.preFillBrief.text.length > 0,
      "is-search": !!_vm.localFilters.originator,
      "retarget-disabled": _vm.retargetAlreadyAdded || _vm.addingToBucket,
      "retarget-loading": _vm.addingToBucket,
      "retarget-tip": _vm.retargetTip
    },
    on: {
      "toggle-display": function($event) {
        _vm.showListeners = !_vm.showListeners
      },
      "load-more": function($event) {
        return _vm.$emit('load-more')
      },
      "open": _vm.openListener,
      "bulk-enrich": function($event) {
        _vm.showBulkEnrich = true
      },
      "retarget": _vm.retargetCurrent,
      "export": function($event) {
        return _vm.startExport()
      },
      "ai-suggest": _vm.handleAiSuggest,
      "reset": _vm.resetFilters
    }
  }), _vm._v(" "), _c('campaign-recommender', {
    ref: "recommender",
    attrs: {
      "data-tour": "recommender",
      "recommendation-result": _vm.recommendationResult,
      "pre-fill": _vm.preFillBrief,
      "listener-channel-counts": _vm.channelCounts,
      "active-filters": _vm.localFilters,
      "credits-exhausted": _vm.creditsExhausted
    },
    on: {
      "recommend": _vm.onRecommend,
      "export-audience": function($event) {
        return _vm.exportRecommended()
      },
      "export-by-channel": function($event) {
        return _vm.exportRecommended($event)
      },
      "cleared": _vm.onRecommenderCleared
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    attrs: {
      "icon": _vm.fabsOpen ? 'fa-chevron-down' : 'fa-th-large',
      "label": _vm.fabsOpen ? 'Hide shortcuts' : 'Show shortcuts',
      "bottom": 32,
      "type": "info",
      "badge": _vm.fabsOpen ? 0 : _vm.shortcutAlerts,
      "tour-key": "fab-toggle"
    },
    on: {
      "open": _vm.toggleFabs
    }
  }), _vm._v(" "), _c('filter-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "bottom": 104,
      "active-count": _vm.activeFilterCount
    },
    on: {
      "open": _vm.openFilters
    }
  }), _vm._v(" "), (!_vm.hideHeader) ? [_c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-search",
      "label": "Find listeners",
      "tour-key": "fab-find",
      "bottom": 176
    },
    on: {
      "open": function($event) {
        _vm.showFind = true
      }
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-users",
      "label": "Audiences",
      "tour-key": "fab-audiences",
      "bottom": 248
    },
    on: {
      "open": function($event) {
        _vm.showAudiences = true
      }
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-bullseye",
      "label": "Advertiser hub",
      "tour-key": "fab-advertiser",
      "bottom": 320
    },
    on: {
      "open": function($event) {
        _vm.showAdvertiserHub = true
      }
    }
  }), _vm._v(" "), _c('find-listeners-modal', {
    attrs: {
      "visible": _vm.showFind,
      "total": _vm.listeners.totalMatches || 0,
      "loading-listeners": _vm.loadingListeners
    },
    on: {
      "close": function($event) {
        _vm.showFind = false
      },
      "search": _vm.findByTerm,
      "view": _vm.scrollToListeners,
      "apply-ai": _vm.applyAiSearch
    }
  }), _vm._v(" "), _c('dashboard-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "icon": "fa-paper-plane",
      "label": "Retarget bucket",
      "tour-key": "fab-bucket",
      "bottom": 392,
      "badge": _vm.bucketItems
    },
    on: {
      "open": _vm.openBucket
    }
  }), _vm._v(" "), _c('ai-usage-fab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fabsOpen),
      expression: "fabsOpen"
    }],
    attrs: {
      "bottom": 464
    }
  }), _vm._v(" "), _c('advertiser-hub-modal', {
    attrs: {
      "visible": _vm.showAdvertiserHub,
      "filters": _vm.bulkEnrichFilters,
      "filter-labels": _vm.bulkEnrichFilterLabels
    },
    on: {
      "close": function($event) {
        _vm.showAdvertiserHub = false
      },
      "pick": _vm.handleHubPick,
      "open-filters": _vm.openFilters
    }
  }), _vm._v(" "), _c('audiences-modal', {
    attrs: {
      "visible": _vm.showAudiences
    },
    on: {
      "close": function($event) {
        _vm.showAudiences = false
      },
      "view-members": _vm.viewAudience,
      "retarget": _vm.retargetAudiences
    }
  }), _vm._v(" "), _c('retarget-bucket-modal', {
    attrs: {
      "visible": _vm.showBucket,
      "groups": _vm.bucket.groups,
      "total": _vm.bucket.total,
      "loading": _vm.bucketLoading
    },
    on: {
      "close": function($event) {
        _vm.showBucket = false
      },
      "changed": _vm.loadBucket,
      "export": function($event) {
        return _vm.startExport($event, true)
      }
    }
  }), _vm._v(" "), _c('export-fields-modal', {
    attrs: {
      "visible": !!_vm.pendingExport,
      "source-label": _vm.pendingExport ? _vm.pendingExport.label : '',
      "bucket": !!(_vm.pendingExport && _vm.pendingExport.bucket),
      "busy": _vm.exporting,
      "consent-total": _vm.exportCounts ? _vm.exportCounts.total : 0,
      "consent-without": _vm.exportCounts ? _vm.exportCounts.without_opt_in : 0,
      "consent-loading": _vm.exportCountsLoading
    },
    on: {
      "close": function($event) {
        _vm.pendingExport = null
      },
      "confirm": _vm.runExport
    }
  }), _vm._v(" "), _c('consent-check-modal', {
    attrs: {
      "visible": !!_vm.consent,
      "purpose": _vm.consent ? _vm.consent.purpose : 'retarget',
      "total": _vm.consent ? _vm.consent.total : 0,
      "without": _vm.consent ? _vm.consent.without : 0
    },
    on: {
      "close": function($event) {
        return _vm.answerConsent(null)
      },
      "confirm": function($event) {
        return _vm.answerConsent($event)
      }
    }
  }), _vm._v(" "), _c('bulk-enrich-modal', {
    attrs: {
      "visible": _vm.showBulkEnrich,
      "segment-counts": _vm.segmentCounts,
      "filters": _vm.bulkEnrichFilters,
      "filter-labels": _vm.bulkEnrichFilterLabels,
      "filter-total": _vm.listeners.totalMatches || 0
    },
    on: {
      "close": function($event) {
        _vm.showBulkEnrich = false
      },
      "finished": _vm.refreshListeners
    }
  })] : _vm._e(), _vm._v(" "), _c('segmentation-tour', {
    attrs: {
      "visible": _vm.tourOpen,
      "steps": _vm.tourSteps
    },
    on: {
      "step": _vm.onTourStep,
      "close": _vm.endTour
    }
  }), _vm._v(" "), (_vm.filtersMounted) ? _c('audience-filters', {
    attrs: {
      "visible": _vm.showFilters,
      "filters": _vm.localFilters,
      "options": _vm.filterOptions,
      "counts": _vm.scopedCounts,
      "segment-counts": _vm.segmentCounts,
      "missing-field-counts": _vm.completeness.missingFieldCounts || {}
    },
    on: {
      "close": function($event) {
        _vm.showFilters = false
      },
      "update": _vm.onFilterUpdate,
      "apply": _vm.applyFilters,
      "reset": _vm.resetFilters
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedListener) ? _c('listener-dialog', {
    attrs: {
      "listener": _vm.selectedListener,
      "visible": _vm.showDialog,
      "enriching": _vm.enriching,
      "enrich-credits-exhausted": _vm.enrichCreditsExhausted,
      "bucket-groups": _vm.bucket.groups,
      "retarget-default-label": _vm.listenerRetargetTarget.label,
      "retargeting": _vm.addingToBucket,
      "match-reason": _vm.dialogReason,
      "audience-name": _vm.matchSourceName
    },
    on: {
      "close": _vm.closeDialog,
      "view-profile": function($event) {
        return _vm.$emit('view-profile', $event)
      },
      "enrich": function($event) {
        return _vm.$emit('enrich', $event)
      },
      "find-similar": function($event) {
        return _vm.$emit('find-similar', $event)
      },
      "retarget": _vm.retargetListener,
      "apply-inferred": function($event) {
        return _vm.$emit('apply-inferred', $event)
      },
      "review-link": function($event) {
        return _vm.$emit('review-link', $event)
      },
      "replace-demographic": function($event) {
        return _vm.$emit('replace-demographic', $event)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc03b69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/segmentation/Dashboard.vue
// module id = 3203
// module chunks = 3